module.exports = __webpack_public_path__ + "static/draft1-ed33c7a370c8fde921b686c7842bc88c.png";